import { mapGetters } from 'vuex'
import help from '@/utils/help'
import other from '@/api/other'

export default {
  components: {},
  data() {
    return {
      loading: false,
      params: {
        INCOMPLETE_SUBMISSION_REPORT: '',
        ACADEMIC_EDITOR_PERFORMANCE_REPORT: '',
        ARTICLE_KEYWORDS_REPORT: '',
        REVIEWERS_REVIEW_RECORD_REPORT: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser',
      journalId: 'getJournalId'
    })
  },

  async mounted() {
    this.params.INCOMPLETE_SUBMISSION_REPORT = await this.getTime(
      'INCOMPLETE_SUBMISSION_REPORT'
    )
    this.params.ACADEMIC_EDITOR_PERFORMANCE_REPORT = await this.getTime(
      'ACADEMIC_EDITOR_PERFORMANCE_REPORT'
    )
    this.params.ARTICLE_KEYWORDS_REPORT = await this.getTime(
      'ARTICLE_KEYWORDS_REPORT'
    )
    this.params.REVIEWERS_REVIEW_RECORD_REPORT = await this.getTime(
      'REVIEWERS_REVIEW_RECORD_REPORT'
    )
  },
  methods: {
    async getTime(type) {
      const time = this.$moment(await other.export(type).updateTime).format(
        'HH:mm DD / MM / YYYY'
      )
      return time
    },
    async exp(type) {
      this.loading = true
      try {
        const res = await other.download(type)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    }
  }
}
